import { messages } from './messages';
import { CompassScope } from './types';
import { componentResultRenderer } from './result-renderer';
var mapAggregatorResponseToSearchItem = function mapAggregatorResponseToSearchItem(response) {
  return {
    title: response.title,
    id: response.id,
    meta: response.ownerId,
    url: response.url,
    icon: response.type,
    containerId: '' // no container
  };
};
export var getSections = function getSections(intl) {
  return [{
    id: CompassScope.Component,
    title: intl.formatMessage(messages.compass_components_section_heading),
    scope: CompassScope.Component,
    showResultCount: true,
    resultRenderer: componentResultRenderer,
    resultMapper: function resultMapper(_ref) {
      var results = _ref.results;
      return results.map(function (value) {
        return mapAggregatorResponseToSearchItem(value);
      });
    }
  }];
};